namespace $.$$ {
	export class $shm_hitalama_guide_editor extends $.$shm_hitalama_guide_editor {
		private baselines = new Map<string, { expected: string, data: $shm_hitalama_guide_document_data }>()
		private drafts = new Map<string, $shm_hitalama_guide_document_data>()
		@ $mol_mem_key
		baseline( id: string, next?: { expected: string, data: $shm_hitalama_guide_document_data } ) {
			if( next ) this.baselines.set( id, next )
			const previous = this.baselines.get( id )
			if( previous ) return previous
			const page = this.catalog().page( id )!
			const data = page.read(), baseline = { data: { ...data, parent: page.parent(), body: this.$.$shm_hitalama_guide_markdown.text(data), links: [] }, expected: page.File()!.remote()!.link().str }
			this.baselines.set( id, baseline ); return baseline
		}
		@ $mol_mem_key
		draft( id: string, next?: $shm_hitalama_guide_document_data ) { if( next ) this.drafts.set( id, next ); return this.drafts.get( id ) ?? this.baseline( id ).data }
		name( next?: string ) { if( next !== undefined ) this.draft( this.id(), { ...this.draft( this.id() ), title: next } ); return this.draft( this.id() ).title }
		content_text( next?: string ) { if( next !== undefined ) this.draft( this.id(), { ...this.draft( this.id() ), body: next } ); return this.draft( this.id() ).body }
		parent( next?: string ) { if( next !== undefined ) this.draft( this.id(), { ...this.draft( this.id() ), parent: next } ); return this.draft( this.id() ).parent ?? '' }
		folder_options() { return this.catalog().folder_options() }
		snapshot() {
			if( !this.name().trim() ) throw new Error( 'Укажите название страницы.' )
			this.catalog().validate_parent( this.id(), this.parent() )
			this.catalog().validate_links( this.$.$shm_hitalama_guide_markdown.references(this.content_text()).map(page=>({page,title:page})) )
			return JSON.stringify({ ...this.draft( this.id() ), links: [] })
		}
		dirty() { return this.catalog().can_change() && this.$.$mol_error_fence( ()=> this.snapshot() !== JSON.stringify( this.baseline( this.id() ).data ), ()=> false ) }
		status() { return this.$.$mol_error_fence( ()=> { this.snapshot(); return '' }, error => this.$.$mol_error_message( error ) ) }
		private requests = new WeakMap<Event, { id: string, snapshot: string, expected: string }>()
		request( event: Event ) {
			let request = this.requests.get( event )
			if( !request ) { request = { id: this.id(), snapshot: this.snapshot(), expected: this.baseline( this.id() ).expected }; this.requests.set( event, request ) }
			return request
		}
		@ $mol_action
		save( event?: Event ) {
			if( !event ) return null
			const request = $mol_wire_sync( this ).request( event ), page = this.catalog().page( request.id )!
			$mol_wire_sync( page ).write( request.snapshot, request.expected )
			const parent=JSON.parse(request.snapshot).parent??''
			if(parent!==(this.baseline(request.id).data.parent??''))page.parent(parent)
			this.baseline( request.id, { data: JSON.parse( request.snapshot ), expected: page.File()!.remote()!.link().str } )
			return null
		}
		@ $mol_action
		cancel( event?: Event ) { if( event ) this.draft( this.id(), this.baseline(this.id()).data ); return null }
		@ $mol_action
		remove( event?: Event ) { if( event ) { this.catalog().remove( this.id() ); this.opened( false ); this.$.$mol_state_arg.value( 'guide_page', null ); this.$.$mol_state_arg.value( 'help_page', null ) }; return null }
		@ $mol_action
		close( event?: Event ) { if( event ) this.opened( false ); return null }
	}
}
